<template>
  <div class="spinner">
    <img src="@/assets/svg/loading.svg" alt="loading"/>
  </div>
</template>

<script>
import authRoles from '@/utils/auth/roles';
import authConfig from '@/utils/auth/auth_config';

export default {
  name: 'callback',
  methods: {
    handleLoginEvent(data) {
      this.$store.dispatch('setUserInfo', data.profile);

      let defaultTarget;

      // If role is present and document.referrer is null (Is first login)
      if (data.profile[authConfig.rolesNamespace] && !document.referrer) {
        const currentRole = Object.values(authRoles).find(role => data.profile[authConfig.rolesNamespace].includes(role.name));

        defaultTarget = currentRole ? currentRole.defaultPage : defaultTarget;
      }
      this.$router.replace(defaultTarget || data.state.target);
    }
  },
  created() {
    this.$auth.handleAuthentication();
  }
};
</script>

<style>
  .spinner {
    position: absolute;
    display: flex;
    justify-content: center;
    height: 100vh;
    width: 100vw;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }
</style>
